import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    typography: {
        fontFamily: '"Noto Sans Bengali", "Hind Siliguri", "Segoe UI", sans-serif',
        fontSize: 16,
        fontWeightRegular: 400,
        fontWeightMedium: 500,
        fontWeightLight: 300,
        lineHeight: 1.75,
        letterSpacing: '0.015em',
        allVariants: {
            wordSpacing: '0.05em',
        },
    },
    components: {
        MuiCard: {
            styleOverrides: {
                root: {
                    boxShadow: 'none',
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    boxShadow: 'none',
                },
            },
        },
        MuiBox: {
            styleOverrides: {
                root: {
                    boxShadow: 'none',
                },
            },
        },
        MuiButtonBase: {
            styleOverrides: {
                root: {
                    boxShadow: 'none',
                },
            },
        },
    },
});

export default theme;
